/*
 * Copyright 2018-2024 CommScope, Inc., All rights reserved.
 *
 * This program is confidential and proprietary to CommScope, Inc. (CommScope), and
 * may not be copied, reproduced, modified, disclosed to others, published or used, in
 * whole or in part, without the express prior written permission of CommScope.
 */

import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { styleLibrary } from 'app/constants';

const LegendWrapper = styled.div.attrs({
  className: 'd-flex justify-content-center mb-5'
})`
  cursor: pointer;
`;

const LegendBlock = styled.div.attrs(props => ({
  className: classNames('d-inline-block mr-3', !props.active && 'inactive')
}))`
  font-weight: bold;
  font-size: ${styleLibrary.fontSizes.body}px;
  margin-left: ${props => (props.name === 'Sessions' ? 120 : 20)}px;

  &.inactive {
    color: ${styleLibrary.disabledText};
    text-decoration: line-through;
  }
`;

const LegendIcon = styled.svg.attrs({
  className: 'd-inline-block mr-1',
  width: 16,
  height: 16
})``;

const OverviewLegendtoolTip = props => {
  const { inactivePlots = [], onClick, onMouseOver, title } = props;

  return (
    <LegendWrapper>
      {props.payload.map(({ dataKey, value, payload }) => {
        const active = !inactivePlots[value];

        return (
          <LegendBlock
            key={value}
            dataKey={dataKey}
            data-test-label={`legend-block-${value}`}
            name={value}
            active={active}
            onClick={() => onClick(value)}
            onMouseOver={() => onMouseOver(value)}
            title={title}
          >
            <LegendIcon>
              <rect
                strokeWidth={2}
                fill={active ? payload.stroke : styleLibrary.lightText}
                stroke={payload.stroke}
                x={0}
                y={0}
                width={16}
                height={16}
              />
            </LegendIcon>
            {value}
          </LegendBlock>
        );
      })}
    </LegendWrapper>
  );
};

OverviewLegendtoolTip.propTypes = {
  inactivePlots: PropTypes.objectOf(PropTypes.bool),
  onClick: PropTypes.func.isRequired,
  payload: PropTypes.array,
  onMouseOver: PropTypes.func,
  title: PropTypes.string
};

export default OverviewLegendtoolTip;
